export class ScrollAnchor {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementById('js-anchor') === null) return
      const anchor = document.getElementById('js-anchor')
      const anchorItem = document.querySelectorAll('.js-anchor_item')
      const anchorItemNode = Array.prototype.slice.call(anchorItem, 0)
      const anchorItemLength = anchorItem.length
      const offsetArray = []
      let currentAnchorIndex = null
      let offsetAdjust = window.innerHeight / 3
      // let offsetAdjust = 0

      // 初期化
      const init = () => {
        // アンカーリンクの設定されたセクションのoffset.top値を配列に格納
        anchorItemNode.forEach(function (item, i) {
          let sectionID = item.querySelector('a').getAttribute('href')
          let sectionIDElm = document.querySelector(sectionID)
          let rect = sectionIDElm.getBoundingClientRect()
          offsetArray[i] = rect.top + window.pageYOffset - offsetAdjust

          // 最後のセクションの末尾のoffset.top値をendプロパティに設定
          if (i === anchorItemLength - 1) {
            const elmHeight = document.defaultView.getComputedStyle(sectionIDElm, null).lineHeight
            offsetArray['end'] = rect.top - offsetAdjust + elmHeight
          }
        })
        // スクロール時にcheckScrollTopを実行
        window.addEventListener('scroll', () => {
          checkScrollTop()
        })
        checkScrollTop()
      }

      // スクロール量をチェックしchangeCurrentNavを実行
      const checkScrollTop = () => {
        for (let i = offsetArray.length; i >= 0; i--) {
          if (window.pageYOffset >= offsetArray[i]) {
            anchorItemNode.forEach(function (item) {
              item.classList.remove('is-act')
            })
            anchorItemNode[i].classList.add('is-act')
            if (anchorItemNode[i].classList.contains('is-white')) {
              anchor.classList.add('-white')
            } else {
              anchor.classList.remove('-white')
            }
            break
          }
        }
        // 最初のセクションに到達していない場合と
        // 最後のセクションの末尾に到達した場合はカレント表示を消す
        // if (window.pageYOffset < offsetArray[0] || window.pageYOffset > offsetArray['end']) {
        //   anchorItemNode.forEach(function (item) {
        //     item.classList.remove('is-act')
        //   })
        // }
      }
      // 初期化処理を実行
      window.addEventListener('load', () => {
        init()
      })
    })
  }
}
